var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

module.exports = function() {
  var $videoModal = $( "#VideoModal" );

  $( "body" ).on( "click", "[data-watch-video]", function( event ) {
    event.preventDefault();

    var videoEmbed = $( this ).attr( "data-watch-video" );

    $videoModal.find( ".modal-content" ).empty().append( videoEmbed );
    $videoModal.modal( "show" );
  });

  $videoModal.on( "hidden.bs.modal", function() {
    $( "#VideoModal" ).find( ".modal-content" ).empty();
  });
};
